import { inject } from '@angular/core';
import { AbstractControl, AsyncValidatorFn } from '@angular/forms';
import { TimezoneService } from '@qaroni-core/services/app/timezone/timezone.service';
import { map } from 'rxjs/operators';

export class TimezoneAsyncValidator {
  public static validate(): AsyncValidatorFn {
    const timezoneService = inject(TimezoneService);
    return (control: AbstractControl) => {
      return timezoneService
        .checkTimezone(control.value)
        .pipe(map(({ result }) => (result ? null : { timezoneError: true })));
    };
  }
}
